var _circle, _ellipse, _path, _path2, _polygon, _polygon2, _polygon3, _path3, _rect, _rect2, _path4, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Whois50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 20,
    fill: "#7debf5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24,
    cy: 24,
    fill: "#3dd9eb",
    rx: 11.645,
    ry: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3dd9eb",
    d: "M4,24c0,3.237,0.769,6.295,2.135,9h35.73C43.231,30.295,44,27.237,44,24s-0.769-6.295-2.135-9H6.135 C4.769,17.705,4,20.763,4,24z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00b3d7",
    d: "M12.355,24c0,3.237,0.448,6.295,1.243,9h20.804c0.795-2.705,1.243-5.763,1.243-9 s-0.448-6.295-1.243-9H13.598C12.803,17.705,12.355,20.763,12.355,24z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2100c4",
    points: "29,29 26.244,29 24,26.573 21.756,29 19,29 19,19 22,19 22,24.317 23.215,23.003 24.785,23.003 26,24.317 26,19 29,19"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2100c4",
    points: "41,29 38.244,29 36,26.573 33.756,29 31,29 31,19 34,19 34,24.317 35.215,23.003 36.785,23.003 38,24.317 38,19 41,19"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#2100c4",
    points: "17,29 14.244,29 12,26.573 9.756,29 7,29 7,19 10,19 10,24.317 11.215,23.003 12.785,23.003 14,24.317 14,19 17,19"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f55376",
    d: "M38,48c-5.522,0-10-4.478-10-10s4.478-10,10-10s10,4.478,10,10S43.522,48,38,48z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 36,
    y: 43,
    fill: "#fac8d5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3.894,
    x: 36,
    y: 38,
    fill: "#fac8d5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fac8d5",
    d: "M38,40h-2v-2l1.936,0c0.858,0,1.68-0.506,1.952-1.321C40.35,35.291,39.323,34,38,34h-2v-2l1.919,0 c1.728,0,3.349,1.051,3.874,2.698C42.672,37.453,40.628,40,38,40z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 2,
    x: 36,
    y: 38,
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Whois50);
export default __webpack_public_path__ + "static/media/icons8-whois-50.f60f2e52587c00080ea621657348d2c7.svg";
export { ForwardRef as ReactComponent };